module.exports = __webpack_public_path__ + "img/header-weddingRingsCrown@2x.63cd0ad.jpg";